import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

import { CaseDetailComponent } from '../../abacus/components/case-detail.component'
import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'
import { BreadcrumbService } from '../../abacus/services/breadcrumb.service'
import { FlashMessageService } from '../../abacus/services/flash-message.service'
import { ResourceService } from '../../abacus/services/resource.service'
import { TaxonomyDetailProperty } from './interfaces/taxonomy-detail-property.interface'
import { TaxonomyDetailRouteData } from './interfaces/taxonomy-detail-route-data.interface'

@Component({
  selector: 'app-taxonomy-detail',
  templateUrl: './taxonomy-detail.component.html',
  standalone: true,
  imports: [CommonModule]
})
export class TaxonomyDetailComponent
  extends CaseDetailComponent
  implements OnInit
{
  properties: TaxonomyDetailProperty[] = []
  definition: ResourceDefinition

  constructor(
    breadcrumbService: BreadcrumbService,
    private readonly detailResourceService: ResourceService,
    private readonly detailFlashMessageService: FlashMessageService,
    private readonly detailRoute: ActivatedRoute
  ) {
    super(
      breadcrumbService,
      detailResourceService,
      detailFlashMessageService,
      detailRoute
    )
  }

  async ngOnInit(): Promise<void> {
    this.definition = (
      this.detailRoute.snapshot.data as TaxonomyDetailRouteData
    ).definition
    await this.initDetailView()

    if (!this.item) {
      return
    }

    this.properties = this.toDetailProperties(this.item)
  }

  private toDetailProperties(
    item: Record<string, unknown>
  ): TaxonomyDetailProperty[] {
    return Object.entries(item)
      .filter(
        ([key]) =>
          !(this.definition.propertiesToExcludeFromDisplay || []).includes(key)
      )
      .map(([key, value]) => ({
        label: this.toLabel(key),
        value: this.getDisplayValue(value)
      }))
  }

  private toLabel(key: string): string {
    return key
      .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
      .replace(/Ids$/, '')
      .replace(/^./, (character) => character.toUpperCase())
  }

  private getDisplayValue(value: unknown): string {
    if (value === null || value === undefined || value === '') return '-'
    if (typeof value === 'boolean') return value ? 'Yes' : 'No'
    if (Array.isArray(value))
      return value.map((item) => this.getDisplayValue(item)).join(', ')
    if (typeof value === 'object') {
      const item = value as Record<string, unknown>
      return this.getDisplayValue(item.name ?? item.label ?? item.id)
    }

    return String(value)
  }
}
